module.exports = __webpack_public_path__ + "img/X70-HQ.51cb3609.png";